'use client';

import CustomButton from '@/components/custom-button';
import { useSidebarStore } from '@/hooks/use-sidebar-store';
import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';

/**Nút toggle menu sidebar */
export const ButtonToogleSidebarMenu = (props: { className?: string }) => {
    const toggleSidebar = useSidebarStore((x) => x.setIsShowMenuOverlay);

    return (
        <CustomButton.Root
            variant='secondary'
            className={cn(
                'absolute left-0 top-1/2 flex h-9 w-10 -translate-y-1/2 items-center justify-center rounded-r-full p-0',
                props.className
            )}
            onClick={() => toggleSidebar((st) => !st)}
        >
            <ChevronRight size={20} strokeWidth={3} />
        </CustomButton.Root>
    );
};
